import apiClient from '@/services/api/apiClient';

export default {
  login: (payload) => apiClient.post('/auth/login', payload),
  refresh: (payload) => apiClient.post('/auth/refresh', payload),
  logout: () => apiClient.post('/auth/logout'),
  issuePasswordReset: (payload) => apiClient.post('/account/issue_password_reset/', payload),
  passwordReset: (payload) => apiClient.post('/account/reset_password/', payload),
};
